import constantsPresupuesto from '@helpers/constants/presupuesto';

const getStatePresupuesto = (nombre) => (constantsPresupuesto.STATES_PRESUPUESTO.find((item) => item.step === nombre));

export default getStatePresupuesto;
